import PublishedEvent from "../models/published-event-list";
import PublishedRaceResult from "../models/published-race-result";
// import { EJSON } from "bson";
export class SupabaseFunctions {
    // @ts-ignore
    private static readonly baseUrl: string = process.env.REACT_APP_SUPABASE_FUNCTION_BASEURL;

    private static async fetchAndParse<T>(url: string): Promise<T> {
        const response = await fetch(url);

        const contentType = response.headers.get("content-type") || "";
        const raw = await response.text();

        if (!response.ok) {
            throw new Error(`Supabase function request failed (${response.status}): ${raw}`);
        }

        const trimmed = raw.trim();

        // Common symptom of returning a JS object without JSON.stringify in an Edge Function.
        if (trimmed === "[object Object]" || trimmed.startsWith("[object ")) {
            throw new Error(
                `Supabase function returned a non-JSON object string (content-type: ${contentType}). ` +
                `Ensure the function uses JSON.stringify on the response body. Body: ${trimmed}`
            );
        }

        const looksLikeJson = trimmed.startsWith("{") || trimmed.startsWith("[");
        if (contentType.includes("application/json") || looksLikeJson) {
            return JSON.parse(trimmed) as T;
        }

        // Fallback: return raw text as-is.
        return raw as unknown as T;
    }

    static async getEventList(orgId: string): Promise<PublishedEvent[]> {
        try {
            const base = (this.baseUrl || "").replace(/\/+$/, "");
            const url = `${base}/getEventList?orgId=${encodeURIComponent(orgId)}`;
            const publishedEvents = await this.fetchAndParse<PublishedEvent[]>(url);
            return publishedEvents || [];
        } catch (error) {
            console.log(error);
        }
        return [];
    }

    static async getEventResultsByEventId(eventId: string): Promise<PublishedRaceResult[]> {
        try {
            const base = (this.baseUrl || "").replace(/\/+$/, "");
            const url = `${base}/getEventResultsByEventId?eventId=${encodeURIComponent(eventId)}`;
            const publishedResults = await this.fetchAndParse<PublishedRaceResult[]>(url);
            return publishedResults || [];
        } catch (error) {
            console.log(error);
        }
        return [];
    }
}